import { useCallback, useEffect, useState } from "react";
import { api } from "services/api.service";
import { Employee } from "types/employee";

export default function useEmployee(uuid: string | undefined) {
  const [employee, setEmployee] = useState<Employee | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const refetch = useCallback(() => {
    if (!uuid) return;
    setIsLoading(true);
    setIsError(false);
    api
      .get<Employee>(`/employees/${uuid}`)
      .then(({ data }) => {
        setEmployee(data);
      })
      .catch(() => {
        setIsError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [uuid]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { employee, isLoading, isError, refetch };
}
